import { dataSplit } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSplit = /*#__PURE__*/createIcon(dataSplit)
export default IconSplit
